import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private toastr: ToastrService
  ) { }

  public info(message: string, title: string = '', config: any = {}) {
    return this.toastr.info(message, title, {
      timeOut: 4000,
      ...config
    }, );
  }

  public success(message: string, title: string = '', config: any = {}) {
    this.toastr.success(message, title, {
      ...config
    });
  }

  public warning(message: string, title: string = '', config: any = {}) {
    this.toastr.warning(message, title, {
      ...config
    });
  }

  public errorValidationCell(message: string, title: string = '', config: any = {}, params: any) {
    const cfg = {
      ...{
        timeOut: 10000,
        extendedTimeOut: 5000,
        closeButton: true,
        tapToDismiss: true,
        enableHtml: true
      },
      ...config
    }
    params.api.flashCells({
      rowNodes: [params.node],
      columns: [params?.colDef?.field],
      flashDelay: 2000,
      fadeDelay: 1000
    });
    return this.toastr.error(message, title, cfg);
  }

  public error(message: string, title: string = '', config: any = {}) {
    const cfg = {
      ...{
        timeOut: 10000,
        extendedTimeOut: 5000,
        closeButton: true,
        tapToDismiss: true,
        enableHtml: true
      },
      ...config
    }

    return this.toastr.error(message, title, cfg);
  }

  public removeMessage(id: any) {
    this.toastr.remove(id);
  }
}
